// WB-INK-004 / WB-TEXT-FMT-001 — place converted text exactly where the ink was: the ink's left edge and
// baseline. Size comes from the trainer's preference when given (opts.size); otherwise it is derived from the
// glyphs present (cap-height vs x-height vs descenders) so it visually matches the handwriting.
import { fontCss } from './whiteboardFonts';

const FALLBACK = { cap: 0.70, xh: 0.52, desc: 0.20, ascent: 1.0 };
const cache = new Map();

const metrics = (font) => {
  const key = font || 'clean';
  if (cache.has(key)) return cache.get(key);
  let m = FALLBACK;
  if (typeof document !== 'undefined') {
    try {
      const ctx = document.createElement('canvas').getContext('2d');
      ctx.font = fontCss(100, key);
      ctx.textBaseline = 'top';
      const cap = ctx.measureText('H').actualBoundingBoxAscent / 100;
      const xh = ctx.measureText('x').actualBoundingBoxAscent / 100;
      const desc = ctx.measureText('g').actualBoundingBoxDescent / 100;
      const ascent = (ctx.measureText('H').fontBoundingBoxAscent || 100) / 100;
      if (cap > 0.3 && xh > 0.2) m = { cap, xh, desc: desc > 0.05 ? desc : FALLBACK.desc, ascent };
    } catch { /* jsdom / no canvas */ }
  }
  cache.set(key, m);
  return m;
};

const TALL = /[A-Z0-9bdfhklt!?()[\]{}/\\|'"#$%&@]/;
const DESC = /[gjpqy,;()[\]{}/\\|@]/;

export const fitTextToInk = (text, box, opts = {}) => {
  const m = metrics(opts.font);
  const lines = text.split('\n');
  const min = opts.min ?? 14, max = opts.max ?? 96;
  const topRatio = TALL.test(text) ? m.cap : m.xh;
  const descRatio = DESC.test(text) ? m.desc : 0;
  if (lines.length > 1) {
    const size = opts.size ?? Math.round(Math.min(max, Math.max(min, box.h / (lines.length * 1.25 - 0.25) / (m.cap + m.desc) * 0.9)));
    return { x: box.x, y: box.y, size };
  }
  const size = opts.size ?? Math.round(Math.min(max, Math.max(min, box.h / (topRatio + descRatio))));
  const baseline = box.y + box.h - descRatio * size;
  return { x: box.x, y: Math.round(baseline - m.ascent * size), size };
};
